import React from "react";
import { Col as FlexCol } from "jsxstyle";

const Col = (props) => <FlexCol {...props} flexDirection="column" boxSizing="border-box" />;

export default Col;
